import { css } from '@emotion/react';
import React, { ReactElement, ReactNode, useContext } from 'react';

import { styled } from '../../styled';
import type { Theme } from '../../theme/interface/detailed';
import { isMobile } from '../../utils/isMobile';
import { DragCtx } from './draggableArea';
import { HeaderIconsContainer } from './headerIconsContainer';

type Interface = {
	className: string;
	hasError?: boolean;
	isInvolve?: boolean;
	children: ReactNode;
	onCloseClick?: VoidFunction;
};

const style = css`
	box-sizing: border-box;
	cursor: move;
	position: relative;
	text-align: center;
	user-select: none;
	display: flex;
	align-items: center;

	& > div:first-of-type {
		flex: 1;
	}
`;

const Component = ({ children, className, onCloseClick, isInvolve, hasError }: Interface): ReactElement => {
	const dragCallbacks = useContext(DragCtx);
	return (
		<div className={className} {...dragCallbacks}>
			<div>{children}</div>
			<HeaderIconsContainer disabledActionIcons={hasError} showAngle={isInvolve} onCloseClick={onCloseClick} />
		</div>
	);
};

const HeaderContainer = styled(Component)(
	({
		theme: {
			allSettings: {
				containers: { chatContainer, headerContainer },
			},
		},
		isInvolve,
	}: {
		theme: Theme;
		isInvolve?: boolean;
	}) => ({
		...headerContainer,
		borderTopLeftRadius: isMobile && !isInvolve ? 0 : chatContainer.borderRadius,
		borderTopRightRadius: isMobile && !isInvolve ? 0 : chatContainer.borderRadius,
	}),
	style
);

export { HeaderContainer };
